import { kebabCase } from 'case-anything';
import 'regenerator-runtime/runtime';

const mapViews = (prefix, views) => {
  const viewsArr = Object.keys(views)
    .filter((v) => views[v].name !== 'Home')
    .map((v) => ({
      path: `/${prefix}/${kebabCase(v)}`,
      name: `${prefix}-${v}`,
      component: views[v],
      meta: views[v].meta,
    }));
  return viewsArr;
};

const rolesGuard = (to, from, next) => {
  if (to.matched.some((record) => record.meta.roles.length > 0)) {
    // console.log(to);
    // router.app.$store.app.roles
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    // if (!auth.loggedIn()) {
    //   next({
    //     path: '/login',
    //     query: { redirect: to.fullPath },
    //   });
    // } else {
    //   next();
    // }
  } else {
    next(); // make sure to always call next()!
  }
};

// eslint-disable-next-line import/prefer-default-export
export default { mapViews, rolesGuard };
